/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Event_Style_Summary_Position_AriaInputs */



/**
* | output |
* | --- |
* | "Vertical position: {label}" |
*
* @param {Event_Style_Summary_Position_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_style_summary_position_aria = /** @type {((inputs: Event_Style_Summary_Position_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Style_Summary_Position_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Position verticale : ${i?.label}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Vertikale Position: ${i?.label}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Posizione verticale: ${i?.label}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Вертикальное положение: ${i?.label}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Posición vertical: ${i?.label}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`垂直位置：${i?.label}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`垂直位置: ${i?.label}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ऊर्ध्वाधर स्थिति: ${i?.label}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Posição vertical: ${i?.label}`)
	return /** @type {LocalizedString} */ (`Vertical position: ${i?.label}`)
});